import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {IReferral} from "../../../services/interfaces/referral-campaigns.interface";

@Component({
  selector: 'app-referral-details',
  templateUrl: './referral-details.component.html',
  styleUrls: ['./referral-details.component.scss']
})
export class ReferralDetailsComponent {

  referralsColumn: string[] = ['count', 'user', 'status', 'activated', 'createdAt', 'rewardCoins'];
  referralsDetails: MatTableDataSource<IReferral> = new MatTableDataSource<IReferral>();

  constructor(public dialogRef: MatDialogRef<ReferralDetailsComponent>,
              @Inject(MAT_DIALOG_DATA) public referrals: IReferral[]) {
    this.referralsDetails = new MatTableDataSource(referrals);
  }

  close() {
    this.dialogRef.close();
  }

}
